"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRadioItemObjectValue = exports.getRadioItemData = exports.isRadioDataObject = void 0;
const general_1 = require("./general");
const isRadioDataObject = (test) => {
    return (typeof test === 'object' &&
        test !== null &&
        (0, general_1.hasOwnProperty)(test, 'value') &&
        typeof test.value === 'string' &&
        (0, general_1.hasOwnProperty)(test, 'label') &&
        (!(0, general_1.hasOwnProperty)(test, 'textBelowLabel') || typeof test.textBelowLabel === 'string') &&
        (!(0, general_1.hasOwnProperty)(test, 'bonusText') || typeof test.bonusText === 'string'));
};
exports.isRadioDataObject = isRadioDataObject;
const getRadioItemData = (value) => {
    if (typeof value === 'string') {
        return {
            value: value,
            label: value,
        };
    }
    else {
        return value;
    }
};
exports.getRadioItemData = getRadioItemData;
const getRadioItemObjectValue = (data, key) => {
    const asObject = (0, exports.getRadioItemData)(data);
    return asObject[key];
};
exports.getRadioItemObjectValue = getRadioItemObjectValue;
